import { IsOptional, IsString, IsUUID, MaxLength } from 'class-validator';

/**
 * Body for `PATCH /admin/iot/gateways/:id` — update name and/or tenant.
 *
 * Tenant reassignment cascades to all sensors in a single transaction:
 * `gateway.tenantId` + `iotSensor.updateMany({ where: { gatewayId }, data: { tenantId: newTenantId, equipmentId: null } })`.
 * Equipment bindings are cleared because they belong to the old tenant.
 */
export class UpdateIotGatewayDto {
  @IsOptional()
  @IsString()
  @MaxLength(120)
  name?: string;

  @IsOptional()
  @IsUUID()
  tenantId?: string;
}
